export const formatPhoneNumber = (phoneNumber: string) => {

  const prefix = "+995"

  const firstDigits = phoneNumber.substring(0, 3)
  const part1 = phoneNumber.substring(3, 5)
  const part2 = phoneNumber.substring(5, 7)
  const part3 = phoneNumber.substring(7, 9)

  return `${prefix} ${firstDigits} ${part1} ${part2} ${part3}`

}